/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Participant_Status_InvitedInputs */



/**
* | output |
* | --- |
* | "Invited" |
*
* @param {Tournaments_Lib_Participant_Status_InvitedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_participant_status_invited = /** @type {((inputs?: Tournaments_Lib_Participant_Status_InvitedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Participant_Status_InvitedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingeladen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Invité")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已邀请")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已邀請")
	if (locale === "ko") return /** @type {LocalizedString} */ ("초대됨")
	return /** @type {LocalizedString} */ ("Invited")
});